import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './Participant.css';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [verificationToken, setVerificationToken] = useState('');
  const [inviteToken, setInviteToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const invite = searchParams.get('invite');
    if (token) setVerificationToken(token);
    if (invite) setInviteToken(invite);
  }, [searchParams]);

  const handleVerifyEmail = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/participant/verify-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          verification_token: verificationToken,
          email: email.toLowerCase().trim(),
        }),
      });

      const data = await response.json();

      if (response.ok && data.verified) {
        // Email verified, proceed to invite page
        navigate(`/participant/invite/${data.invite_token}`);
      } else {
        setError(data.error || 'Verification failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="participant-container">
      <div className="participant-card">
        <h1>Email Verification</h1>
        <p className="subtitle">Please verify your email to continue</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleVerifyEmail}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
            <p className="help-text">Enter the email address you were invited with</p>
          </div>
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailVerification;

